import { getBrowserOfUserAgent, getIsMobile, getPlatformOfUserAgent } from '../userAgent';

/**
 * Custom hook to get user agent information including platform, browser, and mobile status.
 */
export const useUserAgent = () => {
  if (navigator?.userAgent == null)
    return { userAgent: '', platform: 'Unknown', browser: 'Unknown', isMobile: false };
  const userAgent = navigator.userAgent;
  const platform = getPlatformOfUserAgent(userAgent);
  const browser = getBrowserOfUserAgent(userAgent);
  const isMobile = getIsMobile(userAgent);
  return { userAgent, platform, browser, isMobile };
};
